import { Features } from '@ardoq/api-types';
import { FeatureContext, featureOperations } from '@ardoq/features';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import { featureContext$ } from './featureContext$';

export const hasNewSidebarAndNavbar = (
  featureContext: FeatureContext
): boolean =>
  featureOperations.hasFeature(
    featureContext,
    Features.DEPRECATED_NEW_SIDEBAR_AND_NAVBAR
  ) ||
  featureOperations.hasFeature(
    featureContext,
    Features.DISCOVER_CORE_LANDING_PAGE_AND_NAVIGATION
  );

export const hasNewSidebarAndNavbar$: Observable<boolean> =
  featureContext$.pipe(map(hasNewSidebarAndNavbar), distinctUntilChanged());
